import type { ConversationReadingPaneProps } from "./components/ConversationReadingPane";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "ReadingPaneConversation"*/ "./lazyIndex"), { name: "ReadingPaneConversation" });

export const ConversationReadingPane: LazyComponent<ConversationReadingPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.ConversationReadingPane);
